import React, { useState } from "react";
import "../../css/EventsActivities.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const EVENTS = [
  {
    icon: "🏆",
    name: "Annual Sports Day",
    desc: "A day of track and field events, team games, and House-level competition for every grade.",
  },
  {
    icon: "🎭",
    name: "Annual Day",
    desc: "A showcase evening of dance, drama, and music performances put together by students across grades.",
  },
  {
    icon: "🚌",
    name: "Educational Picnics",
    desc: "Grade-wise trips to museums, farms, and heritage sites that turn learning into an outdoor adventure.",
  },
  {
    icon: "🧠",
    name: "Quiz Contests",
    desc: "Inter-house and inter-school quiz competitions that sharpen general knowledge and quick thinking.",
  },
  {
    icon: "🎨",
    name: "Art & Craft Exhibitions",
    desc: "Student artwork and craft projects displayed for parents and peers to appreciate creativity.",
  },
  {
    icon: "🔬",
    name: "Science & STEM Fairs",
    desc: "Hands-on experiments and student-led projects that bring science and technology to life.",
  },
  {
    icon: "🎤",
    name: "Debate & Elocution",
    desc: "Platforms for students to build confidence in public speaking and structured argument.",
  },
  {
    icon: "🎉",
    name: "Festival Celebrations",
    desc: "Cultural festivals celebrated together across the school to build a sense of community.",
  },
  {
    icon: "🤝",
    name: "Community Service Drives",
    desc: "Student-led initiatives such as donation drives and clean-up campaigns that build social responsibility.",
  },
];

const FAQ_ITEMS = [
  {
    q: "What kind of events does Sahara Public School organise through the year?",
    a: "From Sports Day and Annual Day to quiz contests, art exhibitions, and community service drives, students get many chances to showcase their talents throughout the academic year.",
  },
  {
    q: "Are events open to parents?",
    a: "Yes, most major events such as Annual Day, Sports Day, and exhibitions welcome parents to attend and celebrate student achievements.",
  },
  {
    q: "How do events support student development?",
    a: "Events give students real opportunities to build confidence, teamwork, and leadership skills, complementing what they learn in the classroom.",
  },
];

export default function EventsActivities() {
  const [openFaq, setOpenFaq] = useState(0);

  return (<>
      <SchoolHero
        title="Events & Activities"
        subtitle="World-Class Infrastructure"
        image="/images/ea.jpeg"
      />
    <div className="events-page">
    
      <section className="events-hero">
        <h1>Events & Activities</h1>
        <p>
          From Sports Day to Annual Day, from picnics to quiz contests, students
          get a chance to shine in many ways.
        </p>
      </section>

      {}
      <section className="wrap events-intro">
        <div>
          <h2>A Calendar Full of Opportunities</h2>
          <p>
            Throughout the academic year, Sahara Public School organises a wide
            range of events and activities that give students a platform to
            showcase their skills while staying engaged in sports, arts, and
            community service.
          </p>
          <p>
            Our holistic learning approach emphasises age-appropriate events
            that let students explore their talents — from sporting excellence
            to performing arts to community-minded initiatives.
          </p>
        </div>
        <div className="events-intro-img">
          <span className="emoji-badge">🎉</span>
        </div>
      </section>

      {}
      <section className="events-grid-section">
        <div className="wrap">
          <h2>What Happens Through the Year</h2>
          <p>
            A glimpse of the events and activities students look forward to
            every academic year.
          </p>
          <div className="events-grid">
            {EVENTS.map((e) => (
              <div className="event-card" key={e.name}>
                <div className="event-icon">{e.icon}</div>
                <div className="event-name">{e.name}</div>
                <p className="event-desc">{e.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap events-highlight">
        <div className="events-highlight-card">
          <h3>Building Beyond the Classroom</h3>
          <p>
            Every event is designed to give students real-world experience in
            teamwork, leadership, and self-expression — skills that stay with
            them well beyond school.
          </p>
        </div>
      </section>

      {}
      <section className="wrap events-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
    </>
  );
}
